import React from "react";
import './BetLogView.scss';
import { BetLog, BetLogResult} from "../../http/protocol";
import { getContainer } from "../../ioc/IOCSetup";
import { RouteComponentProps, withRouter } from "react-router";
import { LoadingViewState, RouterView } from "../RouterView";
import { formatDate } from "../../util/date";
import { FormSubmitError, FormSubmitSuccess } from "../form/FormFeedback";
import { Form, FormListener } from "../form/Form";
import { SportsBetLogsService } from "../../services/SportsBetLogsService";
import { UserLinkPanel } from "../user/UserLinkPanel";
import { StaticFormValue } from "../form/FormInput";
import { SportBetsService } from "../../services/SportsBetsService";
import { ConfirmModal } from "../../util/ConfirmModal";

interface State extends LoadingViewState {
    betLog?: BetLog;
    updateType?: string;
    validationMap?: any;
    showModal?: boolean;
    dialogText?: string;
    processFailed?: boolean;
    expandedRequest: boolean;
    expandedOriginalRequest: boolean;
}

interface Props extends RouteComponentProps {
}

export class BetLogView extends RouterView<Props, State> implements FormListener<BetLog>{

    service: SportsBetLogsService;
    sportsService: SportBetsService;
    constructor(props: Props) {
        super(props);
        this.service = getContainer().getSportsBetLogsService();
        this.sportsService = getContainer().getSportBetsService();
        this.state = {
            betLog: {}, validationMap: {}, loading: true, showModal: false, dialogText: "", processFailed: undefined,
            expandedRequest: false, expandedOriginalRequest: false
        };
    }

    loadContent(): Promise<any> | undefined {
        let id = (this.props.match.params as any).id;
        return this.service.getEntity(id).then((a: BetLog) => {
            this.setState({ betLog: a, showModal: false, dialogText: "", processFailed: undefined });
        })
    }

    /**
     * Get the bet log request and send it for processing
     * @param betLog
     * @returns
     * @memberof BetLogView
     */
    sendBetLogRequestForProcessing() {
        let betLogRequest = this.state.betLog && this.state.betLog.request!;
        if(betLogRequest===""){
            this.setState({ showModal: true, dialogText: "Error processing event: " + "BetLog request is empty", processFailed: true});
        }
        else{
            this.setState({ showModal: false, dialogText: "" });
            this.sportsService.processEvent(betLogRequest!).then((betlog: BetLog) => {
                if(betlog.result===BetLogResult.ERROR){
                    this.setState({ showModal: true, dialogText: "Error processing event: " + "The bet has been resubmited and the Status is ERROR", processFailed: true });
                }else{
                    this.setState({ showModal: true, dialogText: "Event processed successfully", processFailed: false });
                }
                
            }).catch((error: any) => {
                this.setState({ showModal: true, dialogText: "Error processing event: " + "It was not able to update the bet please retry again", processFailed: true });
            });
        }
    }

    onSubmit(): Promise<any> | undefined {
        return;
    }

    formDidUpdate(formModel: BetLog, validationMap?: any) {
        this.setState({ betLog: formModel, validationMap: validationMap })
    }

    getTitle(): string {
        return "Bet Log Details";
    }



    getJson(request: string | undefined): any {
        try {
            return JSON.parse(request || "{}");
        } catch (error) {
            return request;
        }
    }

    getString(request: any) {
        try {
            return JSON.stringify(request, null, 2);
        } catch (error) {
            return request;
        }
    }

    renderCollapsable(data: string | undefined, expanded: boolean, expand: (value: boolean | undefined)=>void) {

        let json = this.getString(data);

        return (
            <div className={"card-box expandable-box"}>
                {expanded && (
                    <a className="expand-button float-right" onClick={() => expand(false)}><i className="mdi mdi-minus"></i></a>
                )}
                {!expanded && (
                    <a className="expand-button float-right" onClick={() => expand(true)}><i className="mdi mdi-plus"></i></a>
                )}
                <div>
                    <h4 className="header-title mb-3" onClick={() => expand(!expanded)}> ...
                    </h4>
                </div>

                {expanded && (
                    <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word", width: "100%", height: "800px" }}>
                        {json}
                    </pre>
                )}
            </div>
        )
    }

    renderContent() {
        if (!this.state.betLog) {
            return <span></span>
        }
        let betLog: BetLog = this.state.betLog;
        let betLogRequest = this.getJson(betLog.request);
        let originalRequest = this.getJson(betLogRequest["originalRequest"]);
        delete betLogRequest["originalRequest"];

        return (

            <div>
                <ConfirmModal
                    show={this.state.showModal}
                    heading="Process event"
                    description={this.state.dialogText}
                    onCancel={() => this.setState({ showModal: false, dialogText: "", processFailed: undefined })}
                    onOk={() => {
                        if (this.state.processFailed == undefined) {
                            this.sendBetLogRequestForProcessing();
                        } 
                        else if (!this.state.processFailed) {
                            this.setState({ showModal: false, dialogText: "", processFailed: undefined });
                        } 
                        else {
                            this.props.history.push("/sportsbetting/bet/" + this.state.betLog!.betId);
                        }
                    }}
                    okLabel={this.state.processFailed == undefined ? "Process" : "Ok"}
                    okClassName="btn btn-primary"
                    hideCancelButton={this.state.processFailed != undefined}
                    cancelLabel="Cancel"
                    cancelClassName="btn btn-danger"
                />
                <div className={"row"}>
                    <div className="col-lg-6">
                        <Form className="form form-horizontal" validationMap={this.state.validationMap} modelObject={this.state.betLog} formListener={this}>
                            <FormSubmitError />
                            <FormSubmitSuccess text={"Bet Log was updated successfully"} />
                            <StaticFormValue name="betType" className="form-control" model="betType" value={betLog.betType} />
                            <BetLogComponent betLog={betLog} />
                        </Form>
                    </div>
                    <div className="col-lg-6">
                        <div className={"card-box"}>
                            <div className="row">
                                <div className="col-lg-12">
                                    {betLog.userId &&
                                        <UserLinkPanel userId={betLog.userId} header="User" />
                                    }
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <h5>Request
                                        <a className="btn btn-primary btn-xs float-right" onClick={() => this.setState({ showModal: true, dialogText: "Are you sure you want to process this event?", processFailed: undefined })}>
                                            <i className="fa fa-upload"></i> Re-Submit
                                        </a>
                                    </h5>
                                    <small className="text-muted">
                                        {this.renderCollapsable(betLogRequest, this.state.expandedRequest, (value) => this.setState({ expandedRequest: value! }))}
                                    </small>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <h5>Original Request</h5>
                                    <small className="text-muted">
                                        {this.renderCollapsable(originalRequest, this.state.expandedOriginalRequest, (value) => this.setState({ expandedOriginalRequest: value! }))}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default withRouter(BetLogView);

interface BetLogComponentState {
    expanded: boolean;
}

export class BetLogComponent extends React.Component<{ betLog: BetLog }, BetLogComponentState> {

    constructor(props: any) {
        super(props);
        this.state = { expanded: false };
    }

    formatSelections(request: string | undefined): any {
        try {
            let json = JSON.parse(request || "{}");
            return JSON.stringify(json, null, 2);
        } catch (error) {
            return request;
        }
    }

    renderCollapsable(data: string | undefined) {

        let json = this.formatSelections(data);

        return (
            <div className={"card-box expandable-box"}>
                {this.state.expanded && (
                    <a className="expand-button float-right" onClick={() => this.setState({ expanded: false })}><i className="mdi mdi-minus"></i></a>
                )}
                {!this.state.expanded && (
                    <a className="expand-button float-right" onClick={() => this.setState({ expanded: true })}><i className="mdi mdi-plus"></i></a>
                )}
                <div>
                    <h4 className="header-title mb-3" onClick={() => this.setState({ expanded: !this.state.expanded })}> ...
                    </h4>
                </div>

                {this.state.expanded && (
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card-box">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word", width: "100%", height: "800px" }}>
                                            {json}
                                        </pre>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    }


    render() {
        const betLog = this.props.betLog;
        return (
            <div className={"card-box"}>
                <div className="ibox-content">
                    <div className="row">
                        <div className="col-lg-12">
                            <dd className="pull-right">
                                {betLog.result == BetLogResult.SUCCESS &&
                                    <span className="badge badge-success float-right">{betLog.result}</span>
                                }
                                {betLog.result != BetLogResult.SUCCESS &&
                                    <span className="badge badge-error float-right">{betLog.result}</span>
                                }
                            </dd>
                            <h4>Log ID : {betLog.id}</h4>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <table className={"table table-striped"}>
                                <tbody>
                                    <tr>
                                        <td>Result</td>
                                        <td>{betLog.result}</td>
                                    </tr>
                                    <tr>
                                        <td>Timestamp</td>
                                        <td>{formatDate(betLog.timestamp)}</td>
                                    </tr>
                                    <tr>
                                        <td>Integration</td>
                                        <td>{betLog.integration}</td>
                                    </tr>
                                    <tr>
                                        <td>Source</td>
                                        <td>{betLog.source}</td>
                                    </tr>
                                    <tr>
                                        <td>Bet Id</td>
                                        <td>{betLog.betId}</td>
                                    </tr>
                                    <tr>
                                        <td>Group Id</td>
                                        <td>{betLog.groupId}</td>
                                    </tr>
                                    <tr>
                                        <td>Bet Created</td>
                                        <td>{formatDate(betLog.created)}</td>
                                    </tr>
                                    <tr>
                                        <td>Bet Graded Date</td>
                                        <td>{formatDate(betLog.gradedDate)}</td>
                                    </tr>
                                    <tr>
                                        <td>Bet Name</td>
                                        <td>{betLog.name}</td>
                                    </tr>
                                    <tr>
                                        <td>Bet Type:</td>
                                        <td>
                                            {betLog.betType}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Currency</td>
                                        <td>{betLog.currency}</td>
                                    </tr>
                                    <tr>
                                        <td>Risk</td>
                                        <td>{betLog.risk}</td>
                                    </tr>
                                    <tr>
                                        <td>Original Payout</td>
                                        <td>{betLog.originalPayout}</td>
                                    </tr>
                                    <tr>
                                        <td>Payout</td>
                                        <td>{betLog.payout}</td>
                                    </tr>
                                    <tr>
                                        <td>Odds</td>
                                        <td>{betLog.odds}</td>
                                    </tr>
                                    <tr>
                                        <td>Odds Format</td>
                                        <td>{betLog.oddsFormat}</td>
                                    </tr>
                                    <tr>
                                        <td>Status:</td>
                                        <td>
                                            {betLog.status}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Selections</td>
                                        <td>
                                            {this.renderCollapsable(betLog.selections)}
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>Updated</td>
                                        <td>{formatDate(betLog.updated)}</td>
                                    </tr>
                                    <tr>
                                        <td>Updated By</td>
                                        <td>{betLog.updatedBy}</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}